import api from '@/services/api/PricelistSeasons'

const emptyModel = {
  id: null,
  start_date: null,
  end_date: null,
  country_id: null
}

const emptyFilters = {
  country_id: null,
  start_date: null,
  end_date: null
}

export default class PricelistSeason {
  static api = api
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
